import template from './node.html';
import controller from './node';

/* globals TextEditor */

/** @type {TextEditor.Node.Bindings} */
const bindings = {
	kid: '<',
};

/** @type {import('angular').IComponentOptions} */
export default {
	template,
	bindings,
	controller,
};
